import { useNavigate } from "react-router-dom";
import './components/home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faMapMarkerAlt, faStar, faShieldAlt, faCheckCircle, faClock, faArrowRight, faBuilding, faTag, faHandshake, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";
import { useEffect, useState } from "react";
import { getPropertyImageUrl } from "../../../utils/property-image";
import { useLanguage } from "../../../i18n/LanguageContext";

function Home() {

    const navigate = useNavigate();
    const { t } = useLanguage();
    const [featuredProperties, setFeaturedProperties] = useState([]);
  const [isFeaturedLoading, setIsFeaturedLoading] = useState(true);

  const getTypeColor = (type) => {
    switch ((type || '').toLowerCase()) {
      case 'house':      return '#007bff';
      case 'apartment':  return '#28a745';
      case 'villa':      return '#17a2b8';
      case 'studio':     return '#e83e8c';
      case 'cottage':    return '#20c997';
      case 'land':       return '#ffc107';
      case 'commercial': return '#fd7e14';
      case 'condo':      return '#6f42c1';
      case 'cabin':      return '#8B4513';
      case 'room':       return '#ff6b6b';
      default:           return '#6c757d';
    }
  };

  const getTypeLabel = (type) => {
    if (!type) return "";
    const normalized = String(type).trim().toLowerCase().replace(/\s+/g, " ");
    const key = normalized === "office space" ? "officeSpace" : normalized.replace(/\s+/g, "");
    const translated = t(`findProperty.categories.${key}`);
    return translated === `findProperty.categories.${key}`
      ? normalized.charAt(0).toUpperCase() + normalized.slice(1)
      : translated;
  };

    useEffect(() => {
        const fetchFeaturedProperties = async () => {
            try {
                const response = await fetch("/api/properties");
                const data = await response.json();
          const propertyList = Array.isArray(data) ? data : [];
                const featured = propertyList
                    .filter(p => p.price)
                    .sort((a, b) => (b.rating || 0) - (a.rating || 0))
                    .slice(0, 8);
                setFeaturedProperties(featured);
            } catch (error) {
                console.error("Error fetching featured properties", error);
        } finally {
          setIsFeaturedLoading(false);
            }
        };
        fetchFeaturedProperties();
    }, []);

    const handleFindProperty = ()=>{
        navigate("/find-property");
    };
    
    const handleListProperty = ()=>{
        const token = localStorage.getItem("token");
        const role = localStorage.getItem("role");

        if(!token){
            navigate("/login");
            return;
        }
        if(role==="renter"){
            alert("Only owners can list properties");
            navigate("/renter-dashboard");
            return;
        }
        navigate("/list-property");
    }

      const citiesCovered = new Set(featuredProperties.map((property) => property.city).filter(Boolean)).size;
      const averageRent = featuredProperties.length > 0
      ? Math.round(featuredProperties.reduce((sum, property) => sum + (Number(property.price) || 0), 0) / featuredProperties.length)
      : 0;

  return (
    <div className="container home-page">
        <div className="row home-row home-section">
            <div className="col-12 col-lg-6 text-col d-flex flex-column mb-3">
              <div className="p-2">
              <span className="hero-badge">{t('home.hero.badge')}</span>
              </div>
                <div className="p-2">
                    <h1>
                    {t('home.hero.title')}
                    </h1>
                </div>
                <div className="p-2">
                    <p className="text-muted hero-lead">
              {t('home.hero.subtitle')}
                    </p>
                </div>
            <div className="p-2 hero-pill-row">
              <span className="hero-pill"><FontAwesomeIcon icon={faShieldAlt} className="me-2" />{t('home.hero.pillVerified')}</span>
              <span className="hero-pill"><FontAwesomeIcon icon={faCheckCircle} className="me-2" />{t('home.hero.pillDirect')}</span>
              <span className="hero-pill"><FontAwesomeIcon icon={faClock} className="me-2" />{t('home.hero.pillNoBroker')}</span>
                </div>
                <div className="p-2 px-3 hero-action-label">Start here:</div>
                  <div className="p-2 d-flex gap-3 mx-2 hero-cta-group">
                <div>
                      <button className="btn btn-primary hero-cta hero-cta-primary" onClick={handleFindProperty}>
                <FontAwesomeIcon icon={faMagnifyingGlass} className="me-2"/> {t('home.hero.findBtn')}
                    </button>
                </div>
                <div>
                      <button className="btn btn-success hero-cta hero-cta-secondary" onClick={handleListProperty}>
                <FontAwesomeIcon icon={faArrowRight} className="me-2"/> {t('home.hero.listBtn')}
                    </button>
                </div> 
            </div>
              <div className="p-2 hero-subline">Based in Nepal • support@gharbhada.org • Local rental support</div>
        </div>

        <div className="col-12 col-lg-6 hero-pic">
            
        </div>
      </div>

      <div className="trust-proof-bar home-section-alt mb-5">
        <div className="row g-3 align-items-stretch">
          <div className="col-6 col-lg-3">
            <div className="proof-box h-100">
              <div className="proof-icon"><FontAwesomeIcon icon={faBuilding} /></div>
              <div className="proof-value">{featuredProperties.length || 8}+</div>
              <div className="proof-label">{t('home.proof.activeListings')}</div>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <div className="proof-box h-100">
              <div className="proof-icon"><FontAwesomeIcon icon={faMapMarkerAlt} /></div>
              <div className="proof-value">{citiesCovered || 3}+</div>
              <div className="proof-label">{t('home.proof.cities')}</div>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <div className="proof-box h-100">
              <div className="proof-icon"><FontAwesomeIcon icon={faTag} /></div>
              <div className="proof-value">NPR {averageRent ? averageRent.toLocaleString() : "47,625"}</div>
              <div className="proof-label">{t('home.proof.avgRent')}</div>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <div className="proof-box h-100 proof-box--accent">
              <div className="proof-icon"><FontAwesomeIcon icon={faHandshake} /></div>
              <div className="proof-value">NPR 0</div>
              <div className="proof-label">{t('home.proof.brokerFee')}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Properties Section */}
      <div className="featured-section home-section home-section-alt py-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="fw-bold mb-2">{t('home.featured.title')}</h2>
            <p className="text-muted mb-0">{t('home.featured.subtitle')}</p>
          </div>
          <button className="btn btn-outline-primary" onClick={handleFindProperty}>
            {t('home.featured.viewAll')} →
          </button>
        </div>

        <div className="row g-4">
          {isFeaturedLoading ? (
            Array.from({ length: 8 }).map((_, idx) => (
              <div key={idx} className="col-md-6 col-lg-3">
                <div className="card h-100 shadow-sm border-0 featured-skeleton-card">
                  <div className="featured-skeleton-image skeleton-shimmer" />
                  <div className="card-body pb-0">
                    <div className="featured-skeleton-line skeleton-shimmer mb-3" />
                    <div className="featured-skeleton-line short skeleton-shimmer mb-3" />
                  </div>
                  <div className="px-3 mb-2">
                    <div className="featured-skeleton-line short skeleton-shimmer mb-2" />
                    <div className="featured-skeleton-line skeleton-shimmer" />
                  </div>
                </div>
              </div>
            ))
          ) : (
            featuredProperties.map((property) => (
            <div key={property.id} className="col-md-6 col-lg-3">
              <div
                className="card featured-card shadow-sm border-0 h-100"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(`/property/${property.id}`)}
              >
                <div className="position-relative">
                  <img
                    src={property.thumbnail
                      ? getPropertyImageUrl(property.thumbnail, { width: 420 })
                      : property.photos?.[0]
                      ? getPropertyImageUrl(property.photos[0], { width: 420 })
                      : ""}
                    className="card-img-top featured-card-img"
                    alt={property.name}
                    loading="lazy"
                  />
                  {property.type && (
                    <span
                      className="badge featured-type-tag"
                      style={{ backgroundColor: getTypeColor(property.type) }}
                    >
                      {getTypeLabel(property.type)}
                    </span>
                  )}
                  <span className={`badge featured-trust-tag${property.is_verified ? ' featured-trust-tag--verified' : ' featured-trust-tag--unverified'}`}>
                    <FontAwesomeIcon icon={property.is_verified ? faShieldAlt : faCircleXmark} className="me-1" />
                    {property.is_verified ? t('home.featured.verified') : t('home.featured.unverified')}
                  </span>
                </div>

                <div className="card-body pb-0">
                  <h5 className="card-title fw-bold fs-6 mb-1">{property.name}</h5>
                  <p className="fs-6 text-muted mb-2">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="me-1" />
                    {property.state}, {property.city}
                  </p>
                </div>

                <div className="px-3 mb-1">
                  <h5 className="text-success mb-0 fw-bold featured-price">
                    NPR {property.price?.toLocaleString()}
                  </h5>
                  <p className="fs-6 text-muted mb-0">{t('home.featured.perMonth')}</p>
                </div>

                <div className="d-flex justify-content-between text-center px-3 py-2 border-top">
                  <div>
                    <span className="fs-6 fw-normal"><strong>{property.bedrooms}</strong> {t('home.featured.bed')}</span>
                  </div>
                  <div>
                    <span className="fs-6 fw-normal"><strong>{property.bathrooms}</strong> {t('home.featured.bath')}</span>
                  </div>
                  <div>
                    <span className="fs-6 fw-normal"><strong>{property.sqft}</strong> {t('home.featured.sqft')}</span>
                  </div>
                </div>

                <div className="px-3 py-1 text-muted">
                  {(property.amenities || []).slice(0, 3).map((a, i) => (
                    <span key={i} className="me-2 fs-6">{a}</span>
                  ))}
                  {property.amenities && property.amenities.length > 3 && (
                    <span className="fs-6 fw-normal">+{property.amenities.length - 3} more</span>
                  )}
                </div>

                <div className="d-flex justify-content-between align-items-center px-3 pb-2 pt-1">
                  <div className="featured-stars text-warning">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <FontAwesomeIcon
                        key={i}
                        icon={i < Math.round(property.rating || 0) ? faStar : faStarRegular}
                      />
                    ))}
                    <span className="ms-1 text-muted small">({property.reviews || 0})</span>
                  </div>
                </div>

                <div className="px-3 pb-3">
                  <button
                    type="button"
                    className="btn featured-view-btn w-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/property/${property.id}`);
                    }}
                  >
                    {t('home.featured.viewDetails')} <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
                  </button>
                </div>
              </div>
            </div>
          ))
          )}
        </div>
      </div>

      <div className="how-it-works home-section py-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold mb-2">{t('home.howItWorks.title')}</h2>
          <p className="text-muted">{t('home.howItWorks.subtitle')}</p>
        </div>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="how-card h-100 p-4">
              <div className="how-step">1</div>
              <h5 className="fw-bold mt-3">{t('home.howItWorks.step2Title')}</h5>
              <p className="text-muted mb-0">{t('home.howItWorks.step2Desc')}</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="how-card h-100 p-4">
              <div className="how-step">2</div>
              <h5 className="fw-bold mt-3">{t('home.howItWorks.step3Title')}</h5>
              <p className="text-muted mb-0">{t('home.howItWorks.step3Desc')}</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="how-card h-100 p-4">
              <div className="how-step">3</div>
              <h5 className="fw-bold mt-3">{t('home.howItWorks.step4Title')}</h5>
              <p className="text-muted mb-0">{t('home.howItWorks.step4Desc')}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Why Trust Section */}
      <div className="trust-section home-section home-section-alt py-5 rounded">
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-2">{t('home.trust.title')}</h2>
          <p className="text-muted mb-0">{t('home.trust.subtitle')}</p>
        </div>

        <div className="trust-summary mb-5 p-4 p-lg-5">
          <div className="row align-items-center g-4">
            <div className="col-lg-7">
              <h3 className="fw-bold mb-3">{t('home.trust.heading')}</h3>
              <ul className="trust-checklist mb-0">
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" />{t('home.trust.item1')}</li>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" />{t('home.trust.item2')}</li>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" />{t('home.trust.item3')}</li>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" />{t('home.trust.item4')}</li>
              </ul>
            </div>
            <div className="col-lg-5">
              <div className="trust-contact-card p-4">
                <div className="small text-uppercase fw-semibold text-muted mb-2">{t('home.trust.contactHeading')}</div>
                <div className="fw-bold fs-5 mb-2"><a href="mailto:support@gharbhada.org" className="text-dark text-decoration-none">support@gharbhada.org</a></div>
                <div className="text-muted mb-2">{t('home.trust.location')}</div>
                <div className="text-muted">{t('home.trust.hours')}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4 mb-5">
          <div className="col-md-3 text-center">
            <div className="p-4">
              <div className="mb-3">
                <FontAwesomeIcon icon={faShieldAlt} size="3x" className="text-primary" />
              </div>
              <h5 className="fw-bold mb-2">{t('home.trust.feature1Title')}</h5>
              <p className="text-muted small">{t('home.trust.feature1Desc')}</p>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="p-4">
              <div className="mb-3">
                <FontAwesomeIcon icon={faCheckCircle} size="3x" className="text-success" />
              </div>
              <h5 className="fw-bold mb-2">{t('home.trust.feature2Title')}</h5>
              <p className="text-muted small">{t('home.trust.feature2Desc')}</p>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="p-4">
              <div className="mb-3">
                <FontAwesomeIcon icon={faStar} size="3x" className="text-warning" />
              </div>
              <h5 className="fw-bold mb-2">{t('home.trust.feature3Title')}</h5>
              <p className="text-muted small">{t('home.trust.feature3Desc')}</p>
            </div>
          </div>

          <div className="col-md-3 text-center">
            <div className="p-4">
              <div className="mb-3">
                <FontAwesomeIcon icon={faClock} size="3x" className="text-info" />
              </div>
              <h5 className="fw-bold mb-2">{t('home.trust.feature4Title')}</h5>
              <p className="text-muted small">{t('home.trust.feature4Desc')}</p>
            </div>
          </div>
        </div>

        {/* Testimonials */}
        <div className="text-center mb-4">
          <h3 className="fw-bold mb-2">{t('home.testimonials.title')}</h3>
          <p className="text-muted">{t('home.testimonials.subtitle')}</p>
        </div>

        <div className="row g-4">
          <div className="col-md-4">
            <div className="testimonial-card h-100">
              <div className="testimonial-stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <FontAwesomeIcon key={i} icon={faStar} />
                ))}
              </div>
              <p className="testimonial-quote">
                "I found a 2BHK in Lalitpur within a week. No agents calling me every hour — I messaged the owner directly and visited the same day."
              </p>
              <div className="testimonial-footer">
                <div className="testimonial-avatar" style={{ background: 'var(--gb-primary)' }}>AK</div>
                <div>
                  <div className="testimonial-name">Aarav K. <FontAwesomeIcon icon={faCheckCircle} className="text-success ms-1" style={{ fontSize: '0.8rem' }} /></div>
                  <div className="testimonial-meta">{t('home.testimonials.role1')}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="testimonial-card h-100">
              <div className="testimonial-stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <FontAwesomeIcon key={i} icon={faStar} />
                ))}
              </div>
              <p className="testimonial-quote">
                "Listed my flat in Pokhara and got three serious applications in two days. The platform makes it easy to see applicant details without back-and-forth."
              </p>
              <div className="testimonial-footer">
                <div className="testimonial-avatar" style={{ background: '#1a7f4f' }}>SG</div>
                <div>
                  <div className="testimonial-name">Sita G. <FontAwesomeIcon icon={faCheckCircle} className="text-success ms-1" style={{ fontSize: '0.8rem' }} /></div>
                  <div className="testimonial-meta">{t('home.testimonials.role2')}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="testimonial-card h-100">
              <div className="testimonial-stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <FontAwesomeIcon key={i} icon={faStar} />
                ))}
              </div>
              <p className="testimonial-quote">
                "I was worried about scam listings after bad experience on Facebook groups. GharBhada listings felt more reliable — photos matched the actual place."
              </p>
              <div className="testimonial-footer">
                <div className="testimonial-avatar" style={{ background: '#1a6b8a' }}>KT</div>
                <div>
                  <div className="testimonial-name">Kamal T. <FontAwesomeIcon icon={faCheckCircle} className="text-success ms-1" style={{ fontSize: '0.8rem' }} /></div>
                  <div className="testimonial-meta">{t('home.testimonials.role3')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-sticky-cta d-lg-none">
        <button className="btn btn-primary" onClick={handleFindProperty}>
          {t('home.hero.findBtn')}
        </button>
        <button className="btn btn-outline-primary" onClick={handleListProperty}>
          {t('home.hero.listBtn')}
        </button>
      </div>
    </div>
  );
}

export default Home;
